import React, { useState, useEffect } from "react";
import { IoMdCloseCircle } from "react-icons/io";
import Spinner from "react-bootstrap/Spinner";
import { useDispatch, useSelector } from "react-redux";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useLocation } from "react-router-dom";
import { ClientFeedbackDetail, ResetFeedBack } from "../../actions/feedback/customerFeedBackAction";
import "./css/feedBack.scss";

const FeedbackForm = ({ handleClose, showFeedbackModal }) => {
  const [message, setMessage] = useState('');
  const [email, setEmail] = useState('');
  const [buttonLoading, setButtonLoading] = useState(false);
  const dispatch = useDispatch();
  const location = useLocation();
  const loginCheck = localStorage.getItem('isLoggedIn');

  const feedbackStatus = useSelector(state => state.ClientFeedbackReducer);

  // Generate a unique ID for the toast
  const toastId = "feedback-toast-id"; // You can use a static or dynamic ID here

  useEffect(() => {
    if (loginCheck) {
      const clientEmail = localStorage.getItem('email');
      setEmail(clientEmail);
    }
  }, [loginCheck]);

  useEffect(() => {
    if (feedbackStatus?.response) {
      setButtonLoading(false);
      setMessage("");
      
      // Check if the toast with this id is already active
      if (!toast.isActive(toastId)) {
        toast.success("Feedback added successfully!", {
          toastId: toastId // Use the unique toast ID
        });
      }
      
      dispatch(ResetFeedBack());
      setTimeout(() => {
        handleClose(); // Close modal after slight delay
      }, 500);
    }
  }, [feedbackStatus, dispatch, handleClose]);

  const handleSubmit = (e) => {
    e.preventDefault();
    const userAgents = navigator.userAgent;
    const pathName = location.pathname;

    const data = {
      path: pathName,
      userAgent: userAgents,
      email: email,
      comment: message
    };

    dispatch(ClientFeedbackDetail(data));
    setButtonLoading(true);
  };

  const handleMessageChange = (e) => {
    setMessage(e.target.value);
  };

  return (
    <>
      {showFeedbackModal ? (
        <div className="feedback-overlay">
          <div className="feedback-popup">
            <span className="close-button" onClick={handleClose}>
              <IoMdCloseCircle size={24} />
            </span>
            <h2 className="feedback-title">Send Feedback</h2>
            <p className="feedback-subtitle">
              Tell Us What You Love About The App, Or What We Could be Doing Better
            </p>
            <form onSubmit={handleSubmit}>
              <div className="input-group">
                <input
                  type="text"
                  placeholder="Enter Feedback"
                  value={message}
                  onChange={handleMessageChange}
                  className="feedback-input"
                  required
                />
              </div>
              <button
                type="submit"
                className="feedback-submit-btn"
              >
                {buttonLoading ? (
                  <Spinner animation="border" size="sm" variant="light" />
                ) : (
                  "Submit"
                )}
              </button>
              <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="colored"
              />
            </form>
          </div>
        </div>
      ) : null}
    </>
  );
};

export default FeedbackForm;
